import { z } from 'zod';
import { DOCUMENT_KINDS } from './jobRequest.js';
// Status state machine for a per-user document. Drives both the user-facing
// upload widget (which blocks file deletions once an admin has touched the
// row) and the admin queue (which only surfaces `pending_review` by default).
export const USER_DOCUMENT_STATUSES = [
    'unverified',
    'pending_review',
    'approved',
    'rejected',
];
// Legal transitions between document statuses.
//
//   unverified      → pending_review (user uploads first file)
//   pending_review  → approved | rejected (admin review)
//   rejected        → pending_review (user re-uploads after fixing)
//
// approved is terminal in v1; bumping it back to pending_review on re-edit
// is out of scope per docs/REGISTRATION_VERIFICATION_PLAN.md §"Out of scope".
export const USER_DOCUMENT_STATUS_TRANSITIONS = {
    unverified: ['pending_review'],
    pending_review: ['approved', 'rejected'],
    approved: [],
    rejected: ['pending_review'],
};
export const canTransitionUserDocumentStatus = (from, to) => USER_DOCUMENT_STATUS_TRANSITIONS[from].includes(to);
// Public file MIME-types we accept for document uploads. Kept in sync with
// the presign route's content-type allowlist on the API.
export const DOCUMENT_FILE_CONTENT_TYPES = [
    'image/jpeg',
    'image/png',
    'application/pdf',
];
// 10 MB upload cap. Mirrored by the presign route's `maxBytes` check.
export const DOCUMENT_FILE_MAX_BYTES = 10 * 1024 * 1024;
// Input for POST /api/me/documents — a user adding a document type to their
// list after registration. Only `kind` is client-settable; subtype/metadata
// stay server-controlled (NULL/{} on insert).
export const createUserDocumentInputSchema = z.object({
    kind: z.enum(DOCUMENT_KINDS),
});
// Re-export DOCUMENT_KINDS to keep "import from userDocument" ergonomic for
// admin-side consumers, without duplicating the source list.
export { DOCUMENT_KINDS };
//# sourceMappingURL=userDocument.js.map